module.exports = __webpack_public_path__ + "static/media/bridge.f61e609f.svg";